module.exports = __webpack_public_path__ + "img/ES3191.2fba2256.png";